import { FC, useState, useEffect, useMemo } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { ProUpload, ProMessage, ProButton } from '../../antd';
import { minio_upload_api } from '../../api/oss/file';
import classNames from 'classnames';
import { getFileList } from '../utils';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';
import { UploadFile } from 'antd/lib/upload/interface';
import { MinioUploadFileProps } from '../interface';

/** 文件上传 */
const UploadFileC: FC<MinioUploadFileProps> = props => {
  const {
    uploadUrl,
    uploadText,
    fileList,
    uploadIcon,
    disabled,
    maxCount,
    scene,
    listType,
    className,
    size,
    onChange,
    onReset,
    onComplete,
    ...resProps
  } = props;
  const [currentFileList, setCurrentFileList] = useState<UploadFile<any>[]>();
  useEffect(() => {
    if (fileList)
      setCurrentFileList(Array.isArray(fileList) ? fileList : undefined);
  }, [fileList]);
  /** 操作按钮 */
  const uploadButton = () => {
    if (listType === 'picture') {
      return (
        <ProButton icon={uploadIcon} size={size === 'small' ? 'small' : 'middle'}>{uploadText}</ProButton>
      );
    }
    if (listType === 'picture-card') {
      return (
        <div>
          {uploadIcon}
          <div>{uploadText}</div>
        </div>
      );
    }
  };
  const uploadClassName = useMemo(() => {
    return classNames(className, {
      'yb-upload-small': size === 'small',
    });
  }, [size, className]);
  
  return (
    <ProUpload
      name="file"
      fileList={currentFileList}
      listType={listType}
      disabled={disabled}
      multiple={true}
      className={uploadClassName}
      beforeUpload={() => {
        if (maxCount && currentFileList && currentFileList.length >= maxCount) {
          ProMessage.warning(`最多只能上传${maxCount}个文件，请删除后再上传`);
          return false;
        }
        return true;
      }}
      customRequest={async (currentParams: any) => {
        if (!uploadUrl) {
          await onReset?.();
        }
        if (!uploadUrl) return;
        const { data, filename, file } = currentParams;
        const params = new FormData();
        const dataParams = { type: scene, ...data };
        params.set(filename, file);
        if (dataParams) {
          for (let [key, value] of Object.entries(dataParams)) {
            params.set(key, value as string);
          }
        }
        const fileSuffix = /\.\w+$/.exec(file.name);
        const fileName = data.newFileName
          ? `${data.newFileName}${fileSuffix ? fileSuffix[0] : ''}`
          : file.name;
        setCurrentFileList(
          getFileList(currentFileList, file, {
            status: 'uploading',
            name: fileName,
          }),
        );
        const res = await minio_upload_api(uploadUrl, params);
        onComplete?.(res);
        if (res?.code === SUCCESS_STATUS_CODE) {
          const resData = res.data;
          const newFileList = getFileList(currentFileList, file, {
            ...resData,
            status: 'done',
            name: fileName,
            thumbUrl: resData.url,
          });
          setCurrentFileList(newFileList);
          onChange?.(newFileList);
          return;
        }
        setCurrentFileList(
          getFileList(currentFileList, file, {
            status: 'error',
            name: fileName,
          }),
        );
      }}
      onRemove={file => {
        const newFileList = currentFileList?.filter(v => v.uid !== file.uid);
        setCurrentFileList(newFileList);
        onChange?.(
          Array.isArray(newFileList) && newFileList.length
            ? newFileList
            : undefined,
        );
      }}
      showUploadList={{
        showRemoveIcon: !disabled,
      }}
      {...resProps}
    >
      {disabled ? null : uploadButton()}
    </ProUpload>
  );
};

UploadFileC.defaultProps = {
  uploadText: '点击上传',
  uploadIcon: <UploadOutlined />,
  listType: 'picture',
};

export default UploadFileC;
